
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree9a5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree9a5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $92d271d014067a25$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["aT88m","index.430533af.js","cqhaB","mid_ground_cloud_2-min.fd8940e5.png","EosU6","midground_mountains-min.fcc27b4f.png","eAc8H","mid_ground_cloud_1-min.43d652b5.png","cqHsU","farground_cloud_1.97eb9072.png","6Q59W","torpedo.3fd5eec3.png","cbJ9Q","plane_1_blue.4bf9d835.png","8jQZV","plane_2_blue.df65d8f9.png","dQsgc","plane_3_blue.7d0ec18d.png","lsqrd","plane_1_red.7236be4a.png","1B37m","plane_2_red.6361f4a2.png","6MQLZ","plane_3_red.419ba714.png","4JJwr","explosion.31069264.png","4dGFD","Smoke15Frames_White.563ab519.png","bClI6","Smoke15Frames_Black.bd896f7e.png","b6cH7","click.92e05379.mp3","do7XO","joined.a7a4ca91.mp3","lrfNW","background.2ee6fce2.mp3","hnlbi","logo.b93ae0f9.png","h9WNu","button.2a63e86a.png"]'));


//# sourceMappingURL=index.runtime.34759d1b.js.map
